import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import find from 'lodash/find'
import Grid from 'components/grids/Grid'
import { Card, Grid as SemanticGrid } from 'semantic-ui-react'
import FormLabel from 'components/labels/FormLabel'
import FormSwitch from 'components/forms/bases/FormSwitch'
import Image from 'components/images/Image'
import styled from 'styled-components'
import IconButton from 'material-ui/IconButton'
import FontIcon from 'material-ui/FontIcon'
import withStoreLocator from 'store/storeLocator/withStoreLocator'
import { withStoreLocatorPreferences } from 'store/preferences/withPreferences'
import DataWithLabel from '../components/DataWithLabel'

const StoreDetailContainer = styled.div`
  padding: 10px;
  .store-content {
    .row {
      padding: 2px !important;
    }
    .row:last-child {
      padding-bottom: 14px !important;
    }
  }
  .ui.card {
    cursor: unset;
  }
  
`
const ActionButton = styled(IconButton)`
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
  width: 30px !important;
  height: 20px !important;
  span.fa {
    font-size: 18px !important;
  }
`

const findStoreType = (collection, type) => {
  const storeType = find(collection, ({ id }) => id === type)
  return storeType ? `${storeType.name.en}/${storeType.name.th}` : 'Unknown'
}

const StoreDetail = (props) => {
  const {
    name = {},
    image = {},
    isActive,
    address = {},
    phone,
    location = {},
    type,
    mapUrl,
    tags,
    openHours = [],
    currentLang,
    setIsActive,
    onEdit,
    onDelete,
    meta: {
      brand: enableBrand,
      type: enableType,
      banner: enableBanner,
    },
    storeLocatorPreferences: {
      showTypes = false,
      showMapUrl = false,
    } = {},
    storeLocator: {
      types: {
        collections = [],
      } = {},
    } = {},
  } = props
  const bannerWidth = 5
  const contentWidth = enableBanner ? 12 - bannerWidth : 12
  return (
    <StoreDetailContainer>
      <Card fluid>
        <Card.Content>
          <ActionButton
            style={{ float: 'right', display: 'inline-block' }}
            onClick={onDelete}
          >
            <FontIcon className="fa fa-trash" />
          </ActionButton>
          <ActionButton
            style={{ float: 'right', display: 'inline-block' }}
            onClick={onEdit}
          >
            <FontIcon className="fa fa-pencil" />
          </ActionButton>
          <Card.Header>
            {name[currentLang]}
          </Card.Header>
        </Card.Content>
        <Card.Content extra>
          <Grid>
            <Grid.Row>
              {
                enableBanner &&
                <Grid.Column width={bannerWidth}>
                  Image
                </Grid.Column>
              }
              <Grid.Column width={contentWidth}>
                <SemanticGrid className="store-content">
                  <SemanticGrid.Column width={6}>
                    <Grid.Row>
                      <Grid.Column>
                        <DataWithLabel label="Name">
                          {name[currentLang]}
                        </DataWithLabel>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column>
                        <DataWithLabel label="Phone">
                          {phone}
                        </DataWithLabel>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column>
                        <DataWithLabel label="Address">
                          {address[currentLang]}
                        </DataWithLabel>
                      </Grid.Column>
                    </Grid.Row>
                    {showTypes && (
                      <Grid.Row>
                        <Grid.Column>
                          <DataWithLabel label="Store type">
                            {findStoreType(collections, type)}
                          </DataWithLabel>
                        </Grid.Column>
                      </Grid.Row>
                    )}
                    {openHours && (
                      <Grid.Row>
                        <Grid.Column>
                          <DataWithLabel label="Open hour">
                            {openHours.map((hour, i) => {
                              return (
                                <p key={i}>{hour[currentLang]}</p>
                              )
                            })}
                          </DataWithLabel>
                        </Grid.Column>
                      </Grid.Row>
                    )}
                    <Grid.Row>
                      <Grid.Column>
                        <FormSwitch
                          value={isActive}
                          onChange={setIsActive}
                          style={{ marginTop: 10 }}
                          label="Active"
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </SemanticGrid.Column>
                  <SemanticGrid.Column width={6}>
                    {showMapUrl && (
                      <div>
                        <FormLabel>Map (image)</FormLabel>
                        <Image src={mapUrl} centered={false} />
                      </div>
                    )}
                  </SemanticGrid.Column>
                </SemanticGrid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    </StoreDetailContainer>
  )
}

StoreDetail.propTypes = {
  name: PropTypes.shape({
    en: PropTypes.string,
    th: PropTypes.string,
  }),
  image: PropTypes.shape({
    source: PropTypes.string,
    link: PropTypes.string,
    target: PropTypes.string,
  }),
  isActive: PropTypes.bool,
  address: PropTypes.shape({
    en: PropTypes.string,
    th: PropTypes.string,
  }),
  phone: PropTypes.string,
  location: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  tags: PropTypes.array,
  currentLang: PropTypes.string,
  setIsActive: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  meta: PropTypes.shape({
    banner: PropTypes.bool,
    type: PropTypes.bool,
    brand: PropTypes.bool,
  }),
}

StoreDetail.defaultProps = {
  name: {
    en: '',
    th: '',
  },
  image: {
    source: '',
    link: '',
    target: '',
  },
  isActive: undefined,
  address: {
    en: '',
    th: '',
  },
  phone: '',
  location: {
    lat: '',
    lng: '',
  },
  tags: [],
  currentLang: 'en',
  setIsActive: () => {},
  onEdit: () => {},
  onDelete: () => {},
  meta: {
    banner: false,
    type: false,
    brand: false,
  },
}

export default compose(
  withStoreLocator(),
  withStoreLocatorPreferences(),
)(StoreDetail)



// WEBPACK FOOTER //
// ./src/pages/StoreLocator/stores/StoreDetail.js